<template>
    <div>
        <a-button v-if="!selectedIcon" @click="openModal">{{ $t("message.selectIcon") }}</a-button>
        <div v-else @click="openModal" class="selected-icon-wrapper">
            <i :class="`material-icons`">{{ selectedIcon }}</i>
        </div>
        <Modal2 v-if="isModalOpen" @cancel="closeModal" xlarge>
            <template v-slot:title> {{ $t("message.iconPickerTitle") }} </template>
            <div class="icon-search">
                <a-input-search v-model="searchQuery" :placeholder="$t('message.searchIconPlaceholder')" />
            </div>
            <div class="icon-grid">
                <template v-if="searchQuery">
                    <div class="icon-items">
                        <div
                            v-for="icon in filteredIcons"
                            :key="icon.name"
                            class="icon-item"
                            @click="selectIcon(icon.name)"
                        >
                            <i class="material-icons">{{ icon.name }}</i>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div v-for="(icons, category) in groupedIcons" :key="category" class="icon-category">
                        <h3>{{ category }}</h3>
                        <div class="icon-items">
                            <div
                                v-for="icon in icons"
                                :key="icon.name"
                                class="icon-item"
                                @click="selectIcon(icon.name)"
                            >
                                <i class="material-icons">{{ icon.name }}</i>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-if="isLoading" class="skeleton-loader" v-for="n in 10" :key="n"></div>
            </div>
        </Modal2>
    </div>
</template>

<script>
import Modal2 from "../../../components/common/Modal2.vue";
import Fuse from "fuse.js";

export default {
    name: "IconSelector",
    components: {
        Modal2,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            icons: [],
            searchQuery: "",
            isModalOpen: false,
            isLoading: true,
        };
    },
    computed: {
        selectedIcon() {
            return this.value;
        },
        filteredIcons() {
            if (!this.searchQuery) {
                return [];
            }
            const searchQueryLower = this.searchQuery.toLowerCase();
            let result = this.icons.filter((icon) =>
                icon.tags.some((tag) => tag.toLowerCase().includes(searchQueryLower))
            );
            result = _.uniqBy(result, "name");
            return result;
        },
        groupedIcons() {
            let result = this.icons.reduce((acc, icon) => {
                icon.categories.forEach((category) => {
                    if (!acc[category]) {
                        acc[category] = [];
                    }
                    acc[category].push(icon);
                });
                return acc;
            }, {});
            Object.keys(result).forEach((key) => {
                result[key] = _.uniqBy(result[key], "name");
            });
            return result;
        },
    },
    methods: {
        async fetchIcons() {
            try {
                const response = await fetch(
                    "https://s3.eu-central-1.amazonaws.com/static.supsis.live/common/json/material-icons.min.json"
                );
                this.icons = await response.json();
                this.isLoading = false;
            } catch (error) {
                console.error("İkonlar yüklenemedi:", error);
            }
        },
        openModal() {
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
        },
        selectIcon(iconName) {
            this.$emit("input", iconName);
            this.closeModal();
        },
    },
    mounted() {
        this.fetchIcons();
    },
};
</script>

<style lang="scss" scoped>
.material-icons {
    max-width: 32px !important;
    max-height: 32px !important;
}

.selected-icon-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}

.icon-grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    max-height: 60vh;
    overflow-y: auto;
}

.icon-category {
    margin-bottom: 20px;

    h3 {
        margin: 0 0 12px 0;
        font-size: 14px;
        font-weight: 600;
        color: var(--color-text-default, #1a1a1a);
    }
}

.icon-items {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.icon-item {
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    transition: transform 0.2s;
}

.icon-item:hover {
    transform: scale(1.1);
}

.skeleton-loader {
    width: 32px;
    height: 32px;
    background-color: #e0e0e0;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}
</style>
